// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spinner-module--wrapper--2PxrM","pulseSpinner":"Spinner-module--pulseSpinner--2i7sf","pulse":"Spinner-module--pulse--2bV2j"};